export default __webpack_public_path__ + "static/media/element_spec_73.21f9626b.jpg";